
//require('./intrinio-realtime');
//const IntrinioRealtime = require('intrinio-realtime');


//const public_key = process.env.INTRINIO_WEB_SOCKET_KEY;

export default function () {

  let $ticker = $('#js-stock-ticker');

  if ($ticker && $ticker.length > 0) {
    tickerDataUpdate();
    setInterval(tickerDataUpdate, 30000);
  }

  //https://api.iextrading.com/1.0/stock/cetx/quote
  // // debugger;
  // var ir = new IntrinioRealtime({
  //   public_key: public_key,
  //   provider: "iex"
  // });



  // // Listen for quotes
  // ir.onQuote(function (quote) {
  //   console.log('CETX', quote)
  // })

  // // Join channels
  // ir.join("CETX")


  // const socket = io('https://ws-api.iextrading.com/1.0/deep');

  // // Listen to the channel's messages
  // socket.on('message', message => console.log(message))
  // //socket.on('firehose', message => console.log(message))
  // socket.on('quote', quote => console.log(quote))

  // // Connect to the channel
  // socket.on('connect', () => {

  //   // Subscribe to topics (i.e. appl,fb,aig+)
  //   socket.emit('subscribe', JSON.stringify({ symbols: ['cetx'], channels: ['deep'] }));
  //   //socket.emit('subscribe', 'cetx');
  //   //socket.emit('firehose', )

  // })

  // // Disconnect from the channel
  // socket.on('disconnect', () => console.log('Disconnected.'))
}

function getQuote() {

  const url = "https://cloud.iexapis.com/stable/stock/cetx/quote?token=pk_49daa27032d94171aaebc062f5bc7b9a";

  return new Promise((resolve, reject) => {
    $.getJSON(url, { format: "jsonp" }).done(resolve).fail(reject);
  })
}

async function tickerDataUpdate() {
  const cetxQuote = await getQuote();
  setTickerData(cetxQuote)
  setTickerDetailsData(cetxQuote);
}

function setTickerData(cetxQuote) {

  console.log(JSON.stringify(cetxQuote));
  let $ticker = $('#js-stock-ticker');

  let change = cetxQuote.change.toFixed(2).replace(/^0+/, '');
  let changeClass = 'plus-ticker';
  let changeSign = ' + ';

  if (change == 0) {
    changeClass = 'white-ticker';
    changeSign = ' ± ';
  } else if (change < 0) {
    changeClass = 'minus-ticker';
    changeSign = ' - ';
  }

  const htmlView = `
  <div class="price font-bold">
      <span class="font-regular">$</span>${cetxQuote.latestPrice.toFixed(2).replace(/^0+/, '')}
      <span class="font-regular ${changeClass}">${changeSign}</span>
      <span class="${changeClass}">${Math.abs(change)}</span>
  </div>
  <div class="comp-name font-bold">
      CETX <span class="font-regular">(Nasdaq)</span>
  </div>
  `;

  $ticker.parent().removeClass('d-none');
  $ticker.html(htmlView);
}

function setTickerDetailsData(cetxQuote) {
  let $ticker = $('#js-stock-ticker-details');

  if ($ticker && $ticker.length > 0) {
    const upImg = $ticker.attr('data-up-img');
    const downImg = $ticker.attr('data-down-img');

    let percentChange = (cetxQuote.changePercent * 100).toFixed(2).replace(/^0+/, '');
    let change = cetxQuote.change.toFixed(2).replace(/^0+/, '');

    let mktDownClass = '';

    let changeSign = ' + ';
    let percentChangeSign = ' + ';

    if (change == 0) {
      changeSign = ' ± ';
      mktDownClass = ' mkt-no-change '
    } else if (change < 0) {
      changeSign = ' - ';
      mktDownClass = 'mkt-down';
    }

    if (percentChange == 0) {
      percentChangeSign = ' ± '
    } else if (percentChange < 0) {
      percentChangeSign = ' - '
    }

    const htmlView = `
    <div class="stock-price">
          <h1>
              <span>$</span>${cetxQuote.latestPrice.toFixed(2).replace(/^0+/, '')}
          </h1>
      </div>
      <div class="stock-bb"></div>
      <div class="percent-change ${mktDownClass}">
          <h3>
              <img class="img-up" src="${upImg}">
              <img class="img-down" src="${downImg}">
              <span class="font-regular">${changeSign}</span>
              ${Math.abs(change)}

              <span class="font-regular v-devider">|</span>
              <span class="font-regular">${percentChangeSign}</span>
              ${Math.abs(percentChange)}
              <span class="font-regular">%</span>
          </h3>
      </div>
    `;

    $ticker.css('opacity', 1);
    $ticker.html(htmlView);
  }
}
